import { render, staticRenderFns } from "./footBar.vue?vue&type=template&id=62a86f8b&scoped=true"
import script from "./footBar.vue?vue&type=script&lang=js"
export * from "./footBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_v5mjhuasro5cnca5bddsdhezz4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a86f8b",
  null
  
)

export default component.exports